/*=========================================================================================
  File Name: moduleAuth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleHelperState.js'
import mutations from './moduleHelperMutations.js'
import actions from './moduleHelperActions.js'
import getters from './moduleHelperGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
